import { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Images } from '../../../../constants/images';
import { DefaultBackButton } from '../../../Molecules';

import styles from './AddToHomeScreenGuideTemplate.module.css';

export enum PlatformType {
  IOS = 'ios',
  Android = 'android',
}

export type AddToHomeScreenGuideTemplateProps = {
  platformType: PlatformType;
  onSwitchTab: (platformType: PlatformType) => void;
};

export const AddToHomeScreenGuideTemplate = memo(
  ({ platformType, onSwitchTab }: AddToHomeScreenGuideTemplateProps) => {
    const { t } = useTranslation();
    return (
      <div className={styles.addToHomeGuide}>
        <div className={styles.backButtonContainer}>
          <DefaultBackButton />
        </div>

        {/* Tabs */}
        <div className={styles.tabs}>
          <div
            className={`${styles.tab} ${
              platformType === PlatformType.IOS ? styles.active : ''
            }`}
            onClick={() => onSwitchTab(PlatformType.IOS)}
          >
            {t('iOS')}
          </div>
          <div
            className={`${styles.tab} ${
              platformType === PlatformType.Android ? styles.active : ''
            }`}
            onClick={() => onSwitchTab(PlatformType.Android)}
          >
            {t('Android')}
          </div>
        </div>

        {platformType === PlatformType.IOS ? (
          <div className={styles.tabContent}>
            <div className={styles.title}>
              {t('How to Add Web App to Home Screen on iOS')}
            </div>
            <p className={styles.normalText}>
              {t(
                'You can add a website icon to your device Home Screen for quick access to JOYAJOY.',
              )}
            </p>

            <div className={styles.subTitle}>{t('Step 1: Tap Share')}</div>
            <p className={styles.normalText}>
              <Trans i18nKey="Tap the Share icon in the bottom menu bar of Safari.">
                Tap the <span className={styles.boldText}>Share</span> icon in
                the bottom menu bar of Safari.
              </Trans>
            </p>
            <div className={styles.spacer} />
            <img className={styles.screenshot} src={Images.Guide_01} />

            <div className={styles.subTitle}>
              {t('Step 2: Add to your Home Screen')}
            </div>
            <p className={styles.normalText}>
              <Trans i18nKey="Scroll down the list of options, then tap Add to Home Screen.">
                Scroll down the list of options, then tap
                <span className={styles.boldText}>Add to Home Screen</span>.
              </Trans>
            </p>
            <p className={styles.normalText}>
              <Trans i18nKey="Tap Add in the top-right corner of the screen.">
                Tap <span className={styles.boldText}>Add</span> in the
                top-right corner of the screen.
              </Trans>
            </p>
            <div className={styles.spacer} />
            <img className={styles.screenshot} src={Images.Guide_02} />
            <img className={styles.screenshot} src={Images.Guide_03} />

            <div className={styles.subTitle}>
              {t('Step 3: Check the App on Home Screen')}
            </div>
            <p className={styles.normalText}>
              {t('The Web App will now appear on your home screen.')}
            </p>
            <img className={styles.screenshot} src={Images.Guide_04} />
          </div>
        ) : (
          <div className={styles.tabContent}>
            <div className={styles.title}>
              {t('How to Add Web App to Home Screen on Android')}
            </div>
            <p className={styles.normalText}>
              {t(
                'You can add a website icon to your device Home Screen for quick access to JOYAJOY.',
              )}
            </p>

            <div className={styles.subTitle}>{t('Step 1: Tap Menu')}</div>
            <p className={styles.normalText}>
              <Trans i18nKey="Tap the three-dot Menu icon in the top-right corner of the screen.">
                Tap the three-dot <span className={styles.boldText}>Menu</span>{' '}
                icon in the top-right corner of the screen.
              </Trans>
            </p>
            <div className={styles.spacer} />
            <img className={styles.screenshot} src={Images.GuideAn_01} />

            <div className={styles.subTitle}>
              {t('Step 2: Add to your Home Screen')}
            </div>
            <p className={styles.normalText}>
              <Trans i18nKey="Scroll down the list of options, then tap Add to Home Screen.">
                Scroll down the list of options, then tap
                <span className={styles.boldText}>Add to Home Screen</span>.
              </Trans>
            </p>
            <p className={styles.normalText}>
              <Trans i18nKey="Select Create shortcut on the popup.">
                Select <span className={styles.boldText}>Create shortcut</span>{' '}
                on the popup.
              </Trans>
            </p>
            <p className={styles.normalText}>
              <Trans i18nKey="Tap Add on the popup.">
                Tap <span className={styles.boldText}>Add</span> on the popup.
              </Trans>
            </p>
            <div className={styles.spacer} />
            <img className={styles.screenshot} src={Images.GuideAn_02} />
            <img className={styles.screenshot} src={Images.GuideAn_03} />
            <img className={styles.screenshot} src={Images.GuideAn_04} />

            <div className={styles.subTitle}>
              {t('Step 3: Check the App on Home Screen')}
            </div>
            <p className={styles.normalText}>
              {t('The Web App will now appear on your home screen.')}
            </p>
            <img className={styles.screenshot} src={Images.GuideAn_05} />
          </div>
        )}
      </div>
    );
  },
);
